<template>
  <ion-item
    v-if="item"
    :routerLink="navigable !== false
      ? (item.object.type === OBJECT_TYPE_CONTAINER
          ? `/tabs/tree/${item.object.id}`
          : `/item/${item.object.id}/detail`)
      : undefined"
    :detail="navigable !== false"
    class="list-item"
  >
    <slot name="start" />
    <ion-thumbnail v-if="item.images.length > 0">
      <ApiImage
        :uuid="item.images[0]"
        :size="[LIST_IMAGE_THUMBNAIL_SIZE_PX, LIST_IMAGE_THUMBNAIL_SIZE_PX]"
      >
        <template v-if="item.object.logo" #fallback>
          <ApiIcon
            :type="item.object.logo.type"
            :name="item.object.logo.name"
            :iconStyle="item.object.logo.style"
          />
        </template>
      </ApiImage>
    </ion-thumbnail>
    <ion-thumbnail v-else-if="item.object.logo">
      <ApiIcon
        :type="item.object.logo.type"
        :name="item.object.logo.name"
        :iconStyle="item.object.logo.style"
      />
    </ion-thumbnail>
    <ion-label class="ion-text-wrap">
      <h2>
        {{ item.object.name }}
        <!--<span class="date">
          <ion-note>{{ message.added }}</ion-note>
          <ion-icon :icon="chevronForward" size="small" v-if="isIos()"></ion-icon>
        </span>-->
      </h2>
      <!--<h3>{{ item.object.description }}</h3>-->
      <p>
        {{ item.object.description }}
      </p>
    </ion-label>
    <router-link
      v-if="item.object.type === OBJECT_TYPE_CONTAINER"
      :to="`/item/${item.object.id}/detail`"
    >
      <ion-icon :icon="infoIcon"></ion-icon>
    </router-link>
    <!--
      TODO: Inline (i) button,
      v-if="item.object.type === OBJECT_TYPE_CONTAINER"
      :routerLink="`/item/${item.object.id}/detail`"
    -->
    <slot name="end" />
  </ion-item>
</template>

<script setup lang="ts">
import { IonItem, IonLabel, IonThumbnail, IonIcon } from "@ionic/vue";
import {defineProps, defineComponent, computed} from "vue";
import type { PropType } from "vue";
import type { ApiObjectWithReferences } from "@/models/api";
import ApiIcon from "@/components/ApiIcon.vue";
import { OBJECT_TYPE_CONTAINER } from "@/data/constants";
import ApiImage from "@/components/ApiImage.vue";
import { infoIcon } from "@/components/icons/renamed_ionicons";
import { useDevicePixelRatio } from '@vueuse/core';
import { LIST_IMAGE_THUMBNAIL_SIZE_PX } from "@/components/constants";


defineComponent({
  name: "ContainerListItem",
});

const props = withDefaults(defineProps<{
  item: ApiObjectWithReferences | null;
  navigable?: boolean;
}>(), {
  navigable: true,
});

/** Method to check if the platform is iOS **/
const isIos = () => {
  const win = window as any;
  return win && win.Ionic && win.Ionic.mode === "ios";
};

</script>

<style scoped lang="scss">
ion-icon {
  font-size: 25px;
}
ion-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.75em;
}
</style>
